var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import TeamList from "../../../components/Teams/TeamList";
import TeamUserList from "../TeamUserList/TeamUserList";
var Teams = /** @class */ (function (_super) {
    __extends(Teams, _super);
    function Teams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isCreateTeamModalOpen: false,
            currentTeam: false,
            maxPage: false
        };
        return _this;
    }
    Teams.prototype.render = function () {
        var _a = this.props, setCurrentTeam = _a.setCurrentTeam, teams = _a.teams, currentTeam = _a.currentTeam;
        return (React.createElement(React.Fragment, null, currentTeam ? (React.createElement(TeamUserList, { goBack: function () { return setCurrentTeam(null); }, team: currentTeam })) : (React.createElement(TeamList, { teams: teams, setCurrentTeam: setCurrentTeam }))));
    };
    Teams.defaultProps = {
        currentTeam: null
    };
    return Teams;
}(Component));
export default Teams;
